import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { PADDING } from '../utils/constants'

const ChartGrid = ({ gridColor, width, height }) => {
  return (
    <>
      {/* Horizontal Grid */}
      {Array.from({ length: 6 }).map((_, i) => {
        const y = PADDING.t + i * ((height - PADDING.t - PADDING.b) / 5)
        return (
          <line
            key={`h${i}`}
            x1={PADDING.l}
            y1={y}
            x2={width - PADDING.r}
            y2={y}
            stroke={gridColor}
            strokeWidth={1}
            strokeDasharray='6 6'
            opacity={0.3}
          />
        )
      })}

      {/* Vertical Grid */}
      {Array.from({ length: 13 }).map((_, i) => {
        const x = PADDING.l + i * ((width - PADDING.l - PADDING.r) / 12)
        return (
          <line
            key={`v${i}`}
            x1={x}
            y1={PADDING.t}
            x2={x}
            y2={height - PADDING.b}
            stroke={gridColor}
            strokeWidth={1}
            strokeDasharray='6 6'
            opacity={0.15}
          />
        )
      })}
    </>
  )
}

ChartGrid.propTypes = {
  gridColor: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
}

export default memo(ChartGrid)
